export var WithdrawStatusType;
(function (WithdrawStatusType) {
    WithdrawStatusType[WithdrawStatusType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    WithdrawStatusType[WithdrawStatusType["REVIEWING"] = 2] = "REVIEWING";
    WithdrawStatusType[WithdrawStatusType["SUCCESSFUL"] = 3] = "SUCCESSFUL";
    WithdrawStatusType[WithdrawStatusType["THIRD_PARTY_WITHDRAWING"] = 4] = "THIRD_PARTY_WITHDRAWING";
    WithdrawStatusType[WithdrawStatusType["REVIEW_FAIL"] = 5] = "REVIEW_FAIL";
    WithdrawStatusType[WithdrawStatusType["THIRD_PARTY_PARTIAL_FAIL"] = 6] = "THIRD_PARTY_PARTIAL_FAIL";
    WithdrawStatusType[WithdrawStatusType["CANCEL_THIRD_PARTY"] = 7] = "CANCEL_THIRD_PARTY";
    WithdrawStatusType[WithdrawStatusType["THIRD_PARTY_FAIL"] = 8] = "THIRD_PARTY_FAIL";
    WithdrawStatusType[WithdrawStatusType["THIRD_PARTY_HOOK_FAIL"] = 9] = "THIRD_PARTY_HOOK_FAIL";
    WithdrawStatusType[WithdrawStatusType["THIRD_PARTY_DETAIL_HOOK_FAIL"] = 10] = "THIRD_PARTY_DETAIL_HOOK_FAIL";
    WithdrawStatusType[WithdrawStatusType["CANCEL_BY_RE_PAYOUT"] = 11] = "CANCEL_BY_RE_PAYOUT";
    WithdrawStatusType[WithdrawStatusType["FORWARDER_BALANCE_NOT_ENOUGH"] = 12] = "FORWARDER_BALANCE_NOT_ENOUGH";
    WithdrawStatusType[WithdrawStatusType["NO_WAY_CAN_USE"] = 13] = "NO_WAY_CAN_USE";
    WithdrawStatusType[WithdrawStatusType["AFTER_SPLITTING"] = 14] = "AFTER_SPLITTING";
})(WithdrawStatusType || (WithdrawStatusType = {}));
//# sourceMappingURL=WithdrawStatusType.js.map